import React from 'react';
import { Helmet } from 'react-helmet';
import meta from '../logos/meta.png';

const Seo = ({ 
  title = "Matched Edge", 
  description = "The slickest matched betting guidesfor absolute beginners to matched betting pros on the web. Learn how to grow your profit.",
  url = "/",
  image = meta
}) => {
const finalUrl = "https://matchededge.uk" + url
  return (
  <Helmet>
    {/* Basic Meta Tags */}
    <meta charSet="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>{title}</title>
    <meta name="description" content={description} />

    {/* Open Graph / Facebook Meta Tags */}
    <meta property="og:type" content="website" />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={finalUrl} />
    <meta property="og:image" content={image} />

    {/* Twitter Meta Tags */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image} />

    {/* Optional: You can also include a canonical link */}
    <link rel="canonical" href={finalUrl} />
  </Helmet>
)};

export default Seo;
